import { axiosInstance, API_URL } from './api';

export type JobStatus = 'running' | 'done' | 'error' | 'cancelled';
export type JobType = 'chat' | 'daily_plan' | 'weekly_plan';

export interface JobPollEventPayload {
  type: string;
  data: unknown;
}

export interface JobPollResponse {
  status: JobStatus;
  job_type: JobType;
  events: JobPollEventPayload[];
  summary?: string | null;
  result_json?: unknown;
  error?: string | null;
}

export class JobNotFoundError extends Error {
  constructor(public readonly jobId: string) {
    super(`Job ${jobId} not found (expired or never existed)`);
    this.name = 'JobNotFoundError';
  }
}

export const fetchJobStatus = async (jobId: string): Promise<JobPollResponse> => {
  try {
    const { data } = await axiosInstance.get<JobPollResponse>(
      `${API_URL}/api/v1/jobs/${jobId}`
    );
    return data;
  } catch (error: any) {
    if (error?.response?.status === 404) {
      throw new JobNotFoundError(jobId);
    }
    throw error;
  }
};

/** Ask the backend (which proxies to science) to stop a v5 background job. A
 * dropped stream does not do this — only an explicit stop should. Failures are
 * swallowed so the UI can finish stopping even if the job already ended. */
export const cancelChatJob = async (jobId: string): Promise<void> => {
  try {
    await axiosInstance.post(`${API_URL}/api/v1/jobs/${jobId}/cancel`);
  } catch (error) {
    console.warn('Failed to cancel chat job', jobId, error);
  }
};
